import {Persistent, BasicKeys} from '/@/utils/cache/persistent';
import {CacheTypeEnum} from '/@/enums/cacheEnum';
import projectSetting from '/@/settings/projectSetting';
import {TOKEN_KEY, LOGIN_INFO_KEY, TENANT_ID} from '/@/enums/cacheEnum';
import {usePermissionStore} from '/@/store/modules/permission';
import {unref, toRaw} from 'vue';
import {useRouter,useRoute} from 'vue-router';
import { useUserStore } from "/@/store/modules/user";
import { TenantTypeEnum } from "/@/enums/tenantTypeEnum";

const {permissionCacheType} = projectSetting;
const isLocal = permissionCacheType === CacheTypeEnum.LOCAL;


/**
 * 获取token
 */
export function getToken() {
  return getAuthCache(TOKEN_KEY);
}

/**
 * 获取登录信息
 */
export function getLoginBackInfo() {
  return getAuthCache(LOGIN_INFO_KEY);
}

/**
 * 获取租户id
 */
export function getTenantId() {
  return getAuthCache(TENANT_ID);
}

/**
 * 获取用户租户id
 */
export function getUserTenantId(username) {
  return getAuthCache(username);
}

export function getAuthCache<T>(key: BasicKeys) {
  const fn = isLocal ? Persistent.getLocal : Persistent.getSession;
  return fn(key) as T;
}

export function setAuthCache(key: BasicKeys, value) {
  const fn = isLocal ? Persistent.setLocal : Persistent.setSession;
  return fn(key, value, true);
}

/**
 * 移除缓存中的某个属性
 * @param key
 * @update:移除缓存中的某个属性
 * @updateBy:lsq
 * @updateDate:2021-09-07
 */
export function removeAuthCache<T>(key: BasicKeys) {
  const fn = isLocal ? Persistent.removeLocal : Persistent.removeSession;
  return fn(key) as T;
}

export function clearAuthCache(immediate = true) {
  const fn = isLocal ? Persistent.clearLocal : Persistent.clearSession;
  return fn(immediate);
}

/**
 * 检查是否有某个页面权限，参数是配置菜单时填写的路径
 * @param routePath
 */
export function hasPagePermission(routePath) {
  const permissionStore = usePermissionStore();
  let menuList = toRaw(unref(permissionStore.getBackMenuList));
  let pages = flatRoutes(menuList);
  if (!routePath) {
    return false;
  } else {
    return pages.some(item => item === routePath);
  }
}

function flatRoutes(arr=[]) {
  let result = [];
  arr.forEach(item => {
    if (item?.children) {
      result = result.concat(flatRoutes(item?.children));
    } else {
      result.push(item?.paramPath||item?.path)
    }
  })
  return result;
}

// 判断是否是keep-alive缓存的页面
export function isKeepAlivePage(){
  const {currentRoute} =useRouter()
  const route = useRoute();
  let currentMatched = currentRoute?.value.matched||[];
  let currentComponent = currentMatched[currentMatched.length - 1].components?.default;
  return route?.meta?.keepAlive&&route?.name===currentComponent?.name;
}

//判断是cso租户
export function getTenantTypeIsCso() {
  const userStore = useUserStore();
  const userInfo = toRaw(userStore.getUserInfo);
  return userInfo.tenantType === TenantTypeEnum.CSO || userInfo.tenantType === TenantTypeEnum.INDUSTRIAL // 取消租户类型，原药企租户类型也为cso，因此需要兼容
}

//过滤cso中tenantStatus不为1的字典
// tenantStatus   0-禁用，1-正常
export function filterDicByTenantStatus(filterArr, excludeArr = []) {
  return filterArr?.filter((item) => {
    return item?.tenantStatus === 1 || excludeArr.includes(item?.value)
  }) || []
}
